import React from 'react';
import ContactMarquee from '../ContactMarquee';
import { FaTint, FaProcedures, FaHeartbeat, FaClock, FaBed, FaNotesMedical, FaMobileAlt } from 'react-icons/fa';
import { Helmet } from 'react-helmet';


const Dialysis = () => {
  const services = [
    { icon: <FaTint />, name: 'Hemodialysis IP & OP (Adult/Pediatric/Neonatal)' },
    { icon: <FaProcedures />, name: 'Peritoneal Dialysis – CAPD/CCPD (Adult/Pediatric)' },
    { icon: <FaHeartbeat />, name: 'SLED – Sustained Low-Efficiency Dialysis' },
    { icon: <FaClock />, name: 'CRRT – Continuous Renal Replacement Therapy' },
    { icon: <FaBed />, name: 'Nocturnal Dialysis' },
    { icon: <FaNotesMedical />, name: 'Plasmapheresis' },
    { icon: <FaMobileAlt />, name: 'Mobile Dialysis' }
  ];
  return (
    <>
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Dialysis Services</title>
        <meta name="description" content="Columbiaa Hospital is the best multi-speciality hospital in Kasturi Nagar, Bangalore offering advanced dialysis services including hemodialysis, peritoneal dialysis, CRRT, SLED, and nocturnal dialysis. 24/7 kidney care with experienced nephrologists and state-of-the-art dialysis machines. Best kidney hospital in Bangalore." />
        <meta name="keywords" content="dialysis, kidney care, hemodialysis, peritoneal dialysis, CRRT, SLED, Columbiaa Hospital, best multi-speciality hospital, hospital in Kasturi Nagar, hospital in Bangalore, 24/7 dialysis, dialysis center Bangalore, kidney hospital Bangalore, nephrologist Bangalore, nephrology department, kidney treatment, CKD treatment, ESKD treatment, ESRD treatment, acute kidney failure, chronic kidney disease, dialysis near me, best dialysis center, mobile dialysis, nocturnal dialysis, plasmapheresis, kidney transplant support, renal care, dialysis machine, hemodialysis IP OP, peritoneal dialysis CAPD CCPD, SLED dialysis, CRRT dialysis, Columbiaa Hospital dialysis, kidney specialist Bangalore, best kidney hospital India" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Dialysis Services" />
        <meta property="og:description" content="Columbiaa Hospital is the best multi-speciality hospital in Kasturi Nagar, Bangalore offering advanced dialysis services including hemodialysis, peritoneal dialysis, CRRT, SLED, and nocturnal dialysis. 24/7 kidney care with experienced nephrologists." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/lab-dialysis" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/lab-dialysis" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

      <section
        className="page-title py-5"
        style={{
          backgroundImage: "url(assets/images/background/page-title-2.jpg)",
          overflowX: "hidden",
        }}
        aria-label="Laboratory and Dialysis Services at Columbiaa Hospital, Kasturi Nagar, Bangalore"
        title="Columbiaa Hospital, Kasturi Nagar, Bangalore – Laboratory and Dialysis Overview"
      >
        <div
          className="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-35.png)",
          }}
          aria-hidden="true"
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-12 col-md-10 text-center"
              data-aos="fade-right"
              aria-label="Introductory Section: Columbiaa Hospital Laboratory and Dialysis"
              title="Welcome to Columbiaa Hospital's well-equipped Laboratory and Dialysis Unit"
            >
              <div className="title-box my-4 my-md-0">
                <h1 className="display-4" aria-label="Laboratory / Dialysis Services"> Laboratory / Dialysis</h1>
                <p className="lead" aria-label="Columbiaa Hospital - Your Health Care Partner">
                  Columbiaa Hospital – Your Health Care Partner in Kasturi Nagar, Bangalore.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="job-details pb-0">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-8 col-md-12 col-sm-12 content-side" aria-label="Columbiaa Hospital Kasturi Nagar Dialysis Centre Information" title="Columbiaa Hospital, Kasturi Nagar - Dialysis Centre Overview">
              <div className="job-details-content">
                <div className="text" aria-label="About Columbiaa Hospital in Kasturi Nagar" title="Our Story – About Columbiaa Hospital Kasturi Nagar">
                  <h2>About Well-Equipped Dialysis Center </h2>
                  <p aria-label="Columbiaa Hospital Kasturi Nagar Dialysis Services Description" title="State-of-the-Art Dialysis Services at Columbiaa Hospital, Kasturi Nagar">
                    At Columbiaa Hospital, Kasturi Nagar, our state-of-the-art dialysis centre is dedicated to providing world-class renal care with compassion and precision. Designed with the comfort and safety of patients in mind, our centre features well-equipped dialysis machines, stringent infection control protocols, and a serene environment to support physical and emotional well-being. Our experienced nephrologists, skilled nurses, and trained technicians work together to deliver personalised treatment plans tailored to each patient's needs, ensuring optimal outcomes and improved quality of life. Whether managing Chronic Kidney Disease (CKD) or End-Stage Kidney Disease (ESKD), we provide both haemodialysis and peritoneal dialysis options, adhering to international best practices.
                  </p>
                  <p aria-label="Patient Support and Compassionate Care at Columbiaa Hospital Kasturi Nagar" title="Compassionate Care and Support at Columbiaa Hospital, Kasturi Nagar">
                    Beyond medical excellence, we believe in treating every patient with dignity and empathy. Our dedicated staff not only monitors your physical health but also provides counselling and dietary guidance to help you cope with the emotional and lifestyle challenges of kidney disease. We offer flexible scheduling, transparent communication, and continuous support throughout the treatment journey. At Columbiaa Hospital, we are not just a dialysis centre—we are a trusted partner in your health, committed to helping you live a fuller, healthier life despite kidney challenges.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 col-sm-12 mt-5 pt-5" aria-label="Dialysis Facility Image at Columbiaa Hospital, Kasturi Nagar" title="Dialysis Services at Columbiaa Hospital, Kasturi Nagar">
              <div>
                <img
                  src="assets/images/service/dialysis.jpg"
                  alt="State-of-the-art dialysis unit at Columbiaa Hospital, Kasturi Nagar, Bangalore - Advanced kidney care facility"
                  title="Dialysis Services at Columbiaa Hospital, Kasturi Nagar"
                  style={{
                    border: "5px solid teal",
                    borderRadius: "16px"
                  }}
                  loading="lazy"
                  aria-label="Image showing Dialysis Services at Columbiaa Hospital, Kasturi Nagar"
                />
              </div>
            </div>

            <div 
              className="col-lg-12 col-md-12 col-sm-12 column" 
              aria-label="Dialysis Eligibility Information - Columbiaa Hospital, Kasturi Nagar" 
              title="Who Requires Dialysis - Columbiaa Hospital, Kasturi Nagar"
            >
              <div className="related-job">
                <h2 
                  style={{ textAlign: "center" }}  
                  aria-label="Section Title: Who Needs Dialysis at Columbiaa Hospital, Kasturi Nagar" 
                  title="Learn Who Needs Dialysis at Columbiaa Hospital, Kasturi Nagar"
                >
                  Who Needs Dialysis?
                </h2>
              </div>
            </div>

            <section
              className="chooseus-section alternet-2 sec-pad-2 mt-n5"
            >
              <div className="auto-container">
                <div className="row clearfix">
                  <div 
                    className="col-lg-4 col-md-6 col-sm-12 chooseus-block" 
                    aria-label="Acute Kidney Failure Treatment Options at Columbiaa Hospital, Kasturi Nagar" 
                    title="Acute Kidney Failure Dialysis Treatment - Columbiaa Hospital, Kasturi Nagar"
                  >
                    <div
                      className="chooseus-block-one wow fadeInUp animated animated"
                      data-wow-delay="00ms"
                      data-wow-duration="1500ms"
                      aria-label="Acute Kidney Failure Treatment Block at Columbiaa Hospital, Kasturi Nagar"
                      title="Acute Kidney Failure Dialysis Treatment Details at Columbiaa Hospital, Kasturi Nagar"
                    >
                      <div className="inner-box">
                        <h3 aria-label="Acute Kidney Failure Treatment Options at Columbiaa Hospital, Kasturi Nagar">
                          Acute Kidney Failure
                        </h3>
                        <ul role="list" aria-label="Acute kidney failure treatment services">
                          <li aria-label="Emergency dialysis for Acute Kidney Failure at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Emergency dialysis
                          </li>
                          <li aria-label="Toxin removal for Acute Kidney Failure at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Toxin removal
                          </li>
                          <li aria-label="Temporary support for Acute Kidney Failure at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Temporary support
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div 
                    className="col-lg-4 col-md-6 col-sm-12 chooseus-block" 
                    aria-label="Chronic Kidney Disease (CKD) Treatment at Columbiaa Hospital, Kasturi Nagar" 
                    title="Chronic Kidney Disease (CKD) Treatment - Columbiaa Hospital, Kasturi Nagar"
                  >
                    <div
                      className="chooseus-block-one wow fadeInUp animated animated"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                      aria-label="Chronic Kidney Disease (CKD) Treatment Block at Columbiaa Hospital, Kasturi Nagar"
                      title="Chronic Kidney Disease (CKD) Treatment Details at Columbiaa Hospital, Kasturi Nagar"
                    >
                      <div className="inner-box">
                        <h3 aria-label="Chronic Kidney Disease (CKD) Treatment Options at Columbiaa Hospital, Kasturi Nagar">
                          Chronic Kidney Disease (CKD)
                        </h3>
                        <ul role="list" aria-label="Chronic kidney disease treatment services">
                          <li aria-label="Long-term care for Chronic Kidney Disease at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Long-term care
                          </li>
                          <li aria-label="Regular monitoring for Chronic Kidney Disease at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Regular monitoring
                          </li>
                          <li aria-label="Diet guidance for Chronic Kidney Disease at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Diet guidance
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-sm-12 chooseus-block" 
                    aria-label="Kidney Transplant Patients Support at Columbiaa Hospital, Kasturi Nagar" 
                    title="Kidney Transplant Patients Care - Columbiaa Hospital, Kasturi Nagar">
                    <div className="chooseus-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                      <div className="inner-box">
                        <h3 aria-label="Kidney Transplant Patients Care Options at Columbiaa Hospital, Kasturi Nagar">
                          Patients for Kidney Transplant
                        </h3>
                        <ul role="list" aria-label="Kidney transplant patient services">
                          <li aria-label="Pre-transplant support at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Pre-transplant support
                          </li>
                          <li aria-label="Post-surgery care at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Post-surgery care
                          </li>
                          <li aria-label="Health monitoring for kidney transplant patients at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Health monitoring
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-sm-12 chooseus-block mt-5" 
                    aria-label="End-Stage Renal Disease (ESRD) Treatment at Columbiaa Hospital, Kasturi Nagar" 
                    title="End-Stage Renal Disease (ESRD) Care - Columbiaa Hospital, Kasturi Nagar">
                    <div className="chooseus-block-one wow fadeInUp animated animated" data-wow-delay="400ms" data-wow-duration="1500ms">
                      <div className="inner-box">
                        <h3 aria-label="End-Stage Renal Disease (ESRD) Treatment Options at Columbiaa Hospital, Kasturi Nagar">
                          End-Stage Renal Disease (ESRD)
                        </h3>
                        <ul role="list" aria-label="ESRD treatment services">
                          <li aria-label="Permanent dialysis for ESRD at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Permanent dialysis
                          </li>
                          <li aria-label="Symptom relief for ESRD at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Symptom relief
                          </li>
                          <li aria-label="Lifestyle support for ESRD patients at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Lifestyle support
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-sm-12 chooseus-block mt-5" 
                    aria-label="Polycystic Kidney Disease (PKD) Care at Columbiaa Hospital, Kasturi Nagar" 
                    title="Polycystic Kidney Disease (PKD) Treatment - Columbiaa Hospital, Kasturi Nagar">
                    <div className="chooseus-block-one wow fadeInUp animated animated" data-wow-delay="200ms" data-wow-duration="1500ms">
                      <div className="inner-box">
                        <h3 aria-label="Polycystic Kidney Disease (PKD) Care at Columbiaa Hospital, Kasturi Nagar">
                          Polycystic Kidney Disease (PKD)
                        </h3>
                        <ul role="list" aria-label="PKD care services">
                          <li aria-label="Cyst management for PKD at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Cyst management
                          </li>
                          <li aria-label="Genetic care for PKD at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Genetic care
                          </li>
                          <li aria-label="End-stage support for PKD at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> End-stage support
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-sm-12 chooseus-block mt-5" 
                    aria-label="Severe Dehydration or Blood Loss Treatment at Columbiaa Hospital, Kasturi Nagar" 
                    title="Severe Dehydration or Blood Loss Treatment - Columbiaa Hospital, Kasturi Nagar">
                    <div className="chooseus-block-one wow fadeInUp animated animated" data-wow-delay="400ms" data-wow-duration="1500ms">
                      <div className="inner-box">
                        <h3 aria-label="Severe Dehydration or Blood Loss Care at Columbiaa Hospital, Kasturi Nagar">
                          Severe Dehydration or Blood Loss
                        </h3>
                        <ul role="list" aria-label="Severe dehydration treatment services">
                          <li aria-label="Critical support for Severe Dehydration or Blood Loss at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Critical support
                          </li>
                          <li aria-label="Fluid balance for Severe Dehydration or Blood Loss at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Fluid balance
                          </li>
                          <li aria-label="Short-term dialysis for Severe Dehydration or Blood Loss at Columbiaa Hospital, Kasturi Nagar">
                            <i className="flaticon-right-arrow" aria-hidden="true"></i> Short-term dialysis
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <ContactMarquee/>

      <section className="pb-5 bg-light mt-5" aria-label="Dialysis Services Section - Columbiaa Hospital">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="card shadow" title="Overview of Dialysis Services at Columbiaa Hospital">
                <div className="card-body" aria-label="Dialysis Introduction">
                  <h2 className="card-title" title="Dialysis Overview" aria-label="Dialysis">Dialysis</h2>
                  <h5 className="text-muted" title="Best Dialysis Centre and Kidney Hospital in India" aria-label="Top Dialysis and Kidney Hospital in India">
                    Best Hospital for Kidney in India | Best Dialysis Center
                  </h5>
                  <p className="card-text" aria-label="Dialysis Description">
                    Dialysis is a medical process used to cleanse the blood of waste products and extra fluids...
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="card shadow h-100" title="Hemodialysis Information">
                <div className="card-body" aria-label="Hemodialysis Details">
                  <h4 className="card-title" title="Hemodialysis Treatment" aria-label="Hemodialysis">Hemodialysis</h4>
                  <p className="card-text" aria-label="Hemodialysis Process Description">
                    Hemodialysis uses a machine called a Dialyzer to filter blood...
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="card shadow h-100" title="Peritoneal Dialysis Information">
                <div className="card-body" aria-label="Peritoneal Dialysis Details">
                  <h4 className="card-title" title="Peritoneal Dialysis Treatment" aria-label="Peritoneal Dialysis">Peritoneal Dialysis</h4>
                  <p className="card-text" aria-label="Peritoneal Dialysis Process Description">
                    Involves Dialysate solution infused into the peritoneal cavity...
                  </p>
                </div>
              </div>
            </div>

            <div className="card shadow mb-4" title="Dialysis Facilities and Services at Columbiaa Hospital">
              <div className="row">
                <div className="col-md-6">
                  <div className="card-body" aria-label="Dialysis Facilities and Services">
                    <h3 className="card-title" title="Available Dialysis Services" aria-label="Facilities and Services">Facilities & Services</h3>
                    <ul className="list-unstyled mb-0" role="list" aria-label="Dialysis Services List">
                      {services.map((service, index) => (
                        <li key={index} className="d-flex align-items-center mb-2">
                          <span className="me-2 text-primary" aria-hidden="true">{service.icon}</span> {service.name}
                        </li>
                      ))}
                    </ul>
                    <p className="mt-3" aria-label="Hospital Description">
                      <strong title="Columbiaa Hospital in Kasturi Nagar, Bangalore" aria-label="Columbiaa Hospital, Kasturi Nagar">
                          Columbiaa Hospital, Kasturi Nagar
                      </strong>, offers expert kidney care with well-equipped dialysis services under experienced nephrologists and healthcare staff.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 py-4">
                  <img
                    src="assets/images/service/dialysis1.jpeg"
                    alt="Advanced dialysis unit at Columbiaa Hospital, Kasturi Nagar - Professional kidney care facility"
                    title="Dialysis Services at Columbiaa Hospital, Kasturi Nagar"
                    style={{
                      border: "5px solid teal",
                      borderRadius: "16px",
                      width: "80%"
                    }}
                    loading="lazy"
                    aria-label="Image showing Dialysis Services at Columbiaa Hospital, Kasturi Nagar"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dialysis;
